import { Navigate, Route } from "react-router-dom";

import { AgentsTabs } from "./AgentsTabs";
import { AgentSessionDetail } from "./Sessions/AgentSessionDetail";
import { SessionsTab } from "./Sessions/SessionsTab";

/**
 * Route tree for the top-level Agents section.
 *
 * Centralized here (rather than declared inline in `Router.tsx`) so all
 * `/agents/*` routes live in one place — matches the convention used by
 * `ActionsRoutes`, `DatasetsRoutes`, etc.
 *
 * The Agents list page is a parent layout (`AgentsTabs`) with one child
 * route per tab, mounted via the parent's `<Outlet>`. Each tab's path
 * segment is the same string declared on `AgentTab` so the URL is the
 * single source of truth for the active tab. Adding a new tab is two
 * lines: a `<Route path>` here and a corresponding `AgentTab` enum value
 * + `<RobotoStyledTab>` in `AgentsTabs`.
 *
 * The session-detail route is a sibling rather than a child of the
 * layout — the detail page is its own chrome (breadcrumb back to the
 * list), not a body within the tab strip.
 */
export const AgentsRoutes = () => [
  <Route key={"layout"} element={<AgentsTabs />}>
    <Route index element={<Navigate to="sessions" replace />} />
    <Route path="sessions" element={<SessionsTab />} />
    <Route path="*" element={<Navigate to="sessions" replace />} />
  </Route>,
  <Route
    key={"session-detail"}
    path="sessions/:sessionId"
    element={<AgentSessionDetail />}
  />,
];
